import { IconMap } from '@shared/sprite';
import React, { FC } from 'react';
import { Tooltip } from '.';
import { Icon } from './icon';

export const InfoTooltip: FC = ({ children }) => {
  return <Tooltip trigger={<Icon glyph={IconMap.Info} />}>{children}</Tooltip>;
};
